/**
 * Internal dependencies
 */
import { PREFIX_EVENTS_STORE } from '@moderntribe/events/data/utils';

export const SET_INITIAL_STATE = `${ PREFIX_EVENTS_STORE }/SHARING_BLOCK/SET_INITIAL_STATE`;

export const SET_GOOGLE_CALENDAR_LABEL = `${ PREFIX_EVENTS_STORE }/SET_GOOGLE_CALENDAR_LABEL`;

export const SET_ICAL_LABEL = `${ PREFIX_EVENTS_STORE }/SET_ICAL_LABEL`;

export const SET_HAS_ICAL = `${ PREFIX_EVENTS_STORE }/SET_HAS_ICAL`;
export const TOGGLE_ICAL = `${ PREFIX_EVENTS_STORE }/TOGGLE_ICAL`;

export const SET_HAS_GOOGLE_CALENDAR = `${ PREFIX_EVENTS_STORE }/SET_HAS_GOOGLE_CALENDAR`;
export const TOGGLE_GOOGLE_CALENDAR = `${ PREFIX_EVENTS_STORE }/TOGGLE_GOOGLE_CALENDAR`;
